module.exports = {
      id: "clipboard-usage",
      viewBox: "0 0 135.081 135.08",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#clipboard",
      toString: function () {
        return this.url;
      }
    }